import { capitalize } from 'lodash';
import { formatDate } from '../../../utils/date';

const getTitle = ({
    seasonDateBegin, seasonDateEnd, seasonYearBegin,
    seasonYearEnd, countryCode, raceType,
}) => {
    const seasons = seasonYearEnd - seasonYearBegin < 4 ?
        'current season' : 'last 5 seasons';
    const dateBegin = formatDate(seasonDateBegin, 'MMM Y');
    const dateEnd = formatDate(seasonDateEnd, 'MMM Y');
    const type = raceType === 'jumps' ? raceType : capitalize(raceType);

    const race = `${countryCode} ${type}`;
    const season = `${seasons} ${dateBegin} - ${dateEnd}`;
    const option = `${race} ${season}`;

    return { race, season, option };
};

export default getTitle;



// WEBPACK FOOTER //
// ./src/js/human/details/helpers/getTitle.js